export default __webpack_public_path__ + "static/media/icon.44bd99a8.png";